<template>
	<BasicLayout>
		<el-row>
			<el-col :xs='{span: 24, offset: 0}' :md='{span: 18, offset: 3}' :lg='{span: 16, offset: 4}' :xl='{span: 14, offset: 5}'>
				<el-tabs type="border-card" v-model="tabName" :before-leave="handleTabChange" class="medications-tabs">
					<el-tab-pane name="Medications" :lazy="true">
						<span slot="label"><i class="fas fa-fw fa-prescription-bottle-alt"></i><span class="hidden-xs-only"> Médicaments</span></span>
						<div v-if="tabName==='Medications'">
							<MedicationTab v-if="!!itemId" />
							<MedicationsTab v-else />
						</div>
					</el-tab-pane>
					<el-tab-pane name="GiveModes" :lazy="true">
						<span slot="label"><i class="fas fa-fw fa-syringe"></i><span class="hidden-xs-only"> Modes administration</span></span>
						<div v-if="tabName==='GiveModes'">
							<GiveModeTab v-if="!!itemId" />
							<GiveModesTab v-else />
						</div>
					</el-tab-pane>
					<el-tab-pane name="Gestures" :lazy="true">
						<span slot="label"><i class="fas fa-fw fa-hand-holding-medical"></i><span class="hidden-xs-only">  Gestes</span></span>
						<div v-if="tabName==='Gestures'">
							<GestureTab v-if="!!itemId" />
							<GesturesTab v-else />
						</div>
					</el-tab-pane>
				</el-tabs>
			</el-col>
		</el-row>
	</BasicLayout>
</template>

<script>
import BasicLayout from '@/layouts/basic.layout'
import MedicationsTab from '@/components/medications/medications.tab.component.vue'
import MedicationTab from '@/components/medications/medication.tab.component.vue'
import GiveModesTab from '@/components/medications/giveModes.tab.component.vue'
import GiveModeTab from '@/components/medications/giveMode.tab.component.vue'
import GesturesTab from '@/components/medications/gestures.tab.component.vue'
import GestureTab from '@/components/medications/gesture.tab.component.vue'

export default {
	components: {
		BasicLayout,
		MedicationsTab,
		MedicationTab,
		GiveModesTab,
		GiveModeTab,
		GesturesTab,
		GestureTab
	},
	data: function () {
		return {
			tabName: this.$route.meta.activeTab
		}
	},
	computed: {
		itemId() {
			return this.$route.params.itemId
		}
	},
	methods: {
		handleTabChange(newName, oldName) {
			if (newName !== oldName) {
				this.$router.push({ name: newName })
				return true
			}
			return false
		}
	}
}
</script>

<style scoped>
.medications-tabs {
	height: calc(100vh - 165px);
}

@media only screen and (max-width:767px) {

	.medications-tabs {
		height: calc(100vh - 120px) !important;
	}
}

</style>